import axios from 'axios';

import type { IGenericUserSuggestedUpdateClass } from '@bb/users';
import type { AxiosRequestBuilder } from '@/app-package';

export interface IGetUpdateSuggestionsForUserParams {
  userId: string;
}
export declare type IGetUpdateSuggestionsForUserRequest = AxiosRequestBuilder<
  IGetUpdateSuggestionsForUserParams,
  'get'
>;
export declare type IGetUpdateSuggestionsForUserResponse =
  IGenericUserSuggestedUpdateClass[];

const getUpdateSuggestionsForUser = async (
  params: IGetUpdateSuggestionsForUserParams,
) => {
  const url = `/suggested_user_updates/update_suggestions/${params.userId}`;

  const config: IGetUpdateSuggestionsForUserRequest = { url, method: 'get' };

  const { data } =
    await axios.request<IGetUpdateSuggestionsForUserResponse>(config);

  return data;
};

export default getUpdateSuggestionsForUser;
